import React from 'react'
import styled from 'styled-components'
import ParseContent from '../shared/ParseContent'

const Section = styled.section`
  position: relative;

  @media (min-width: 992px) {
    padding-top: 123px;
    padding-bottom: 100px;
  }

  @media (max-width: 991.98px) {
    padding-block: 2rem;
  }
`

const Measure = styled.div`
  position: relative;
  max-width: 980px;
  margin-inline: auto;
`

const Mark = styled.svg`
  position: absolute;
  z-index: 1;

  @media (min-width: 992px) {
    top: -82px;
    left: 0;
  }

  @media (max-width: 991.98px) {
    top: -0.5rem;
    left: 0;
    width: 45px;
    height: auto;
  }
`

const Quote = styled.div`
  position: relative;
  z-index: 2;

  & p {
    font-style: italic;
    font-weight: 600;
    text-align: justify;
    margin-bottom: 0;
  }

  /* The attribution underneath the quote. */
  & p:last-child {
    color: #d50021 !important;
    font-style: normal;
    font-weight: 400;
    text-align: left;
    margin-top: 25px;
  }

  @media (min-width: 992px) {
    padding-left: 100px;

    & p {
      font-size: 30px;
      line-height: 40px;
    }

    & p:last-child {
      font-size: 25px;
      line-height: 40px;
    }
  }

  @media (max-width: 991.98px) {
    padding-left: 60px;

    & p {
      font-size: 20px;
      line-height: 30px;
    }

    & p:last-child {
      font-size: 16px;
    }
  }
`

function QuoteLanding({ quote }) {
  return (
    <Section>
      <div className="container">
        <Measure>
          <Mark
            xmlns="http://www.w3.org/2000/svg"
            width="131.5"
            height="117"
            viewBox="0 0 131.5 117"
            fill="none"
          >
            <path
              d="M0 75.5C0 54.5 1.16667 38.8333 3.5 28.5C6.16667 18.1667 11.3333 10.8333 19 6.50002C26.6667 2.16668 38.6667 0 55 0V22.5C45 22.5 38.5 24.8333 35.5 29.5C32.8333 34.1667 31.5 43.5 31.5 57.5V65H51V117H0V75.5ZM76 75.5C76 54.5 77.3333 38.8333 80 28.5C82.6667 18.1667 87.8333 10.8333 95.5 6.50002C103.167 2.16668 115.167 0 131.5 0V22.5C121.5 22.5 115 24.8333 112 29.5C109 34.1667 107.5 43.5 107.5 57.5V65H127V117H76V75.5Z"
              fill="#DEDEDE"
            />
          </Mark>

          <Quote>
            <ParseContent content={quote} />
          </Quote>
        </Measure>
      </div>
    </Section>
  )
}

export default QuoteLanding
